import { Calendar, Factory, Users } from "lucide-react";
import React from "react";

import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { useGetManuFacturerSummary } from "../../hooks";

export const Dashboard: React.FC = () => {
  const { data: manufacturerSummary } = useGetManuFacturerSummary();

  const statsData = [
    {
      title: "Total Manufacturers",
      count: manufacturerSummary?.totalManufacturers || 0,
      trendSummary: "Active manufacturers",
      icon: <Factory className="h-7 w-7 text-blue-500" />,
    },
    {
      title: "Manufacturers with Critical Assets",
      count: manufacturerSummary?.manufacturersWithCriticalAssets || 0,
      icon: <Users className="h-7 w-7 text-green-500" />,
    },
    {
      title: "New Manufacturers (Last 1 Year)",
      count: manufacturerSummary?.newManufacturers || 0,
      trendSummary: "Recently added",
      icon: <Calendar className="h-7 w-7 text-amber-500" />,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {statsData.map((stat, index) => (
        <QuickStatsCard
          key={index}
          title={stat.title}
          count={stat.count}
          trendSummary={stat.trendSummary}
          icon={stat.icon}
        />
      ))}
    </div>
  );
};
